/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * WorshipInitiative.Devo.Api
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

/**
 * This will send a text using Twilio's Verify service to send a text to the user with a code. Requires a valid Turnstile token.
 * @summary Send login code from Twilio (Turnstile protected)
 */
export const postApiAuthV2LoginBodyTurnstileTokenDefault = "1x00000000000000000000AA";

export const postApiAuthV2LoginBody = zod.object({
  "phone": zod.string().nullable(),
  "turnstileToken": zod.string().nullable()
})


/**
 * This will verify the code sent via PBT/Twilio's Verify service.  If successful, a secure
            HTTP-only cookie will be issued
 * @summary Verifies the user's code from PBT for US/CA and Twilio for Int'l
 */
export const postApiAuthVerifyBody = zod.object({
  "phone": zod.string().nullable(),
  "code": zod.string().nullable(),
  "timezone": zod.string().nullish()
})


/**
 * Only works on *.theworshipinitiative.com
 * @summary Get temp token for sing.[env.]theworshipinitiative.com redirect
 */
export const getApiAuthGetRedirectTokenResponse = zod.string()


/**
 * Authenticates temp token from devo.[env.]theworshipinitiative.com and writes cookie for [env.]theworshipinitiative.com
 * @summary Cookie update for sing.[env.]theworshipinitiative.com redirect
 */
export const getApiAuthRedirectCookieQueryParams = zod.object({
  "token": zod.string().optional()
})


/**
 * Called by front end periodically while a user listens to a devo
 * @summary Add devo listen progress event
 */
export const postApiDevosListenEventBody = zod.object({
  "cmsId": zod.string().nullable(),
  "progressPercentage": zod.number().optional()
})


/**
 * Returns user's latest progress for specified devos, or top recent in-progress if none specified. Includes completion timestamp when user has reached 90%+ progress.
 * @summary Get latest devo listen progress
 */
export const getApiDevosProgressQueryParams = zod.object({
  "cmsId": zod.array(zod.string()).optional()
})

export const getApiDevosProgressResponseItem = zod.object({
  "cmsId": zod.string().nullable(),
  "progressPercentage": zod.number().optional(),
  "lastListenedUtc": zod.string().datetime({}).nullish(),
  "completedAtUtc": zod.string().datetime({}).nullish()
})
export const getApiDevosProgressResponse = zod.array(getApiDevosProgressResponseItem)


/**
 * Returns user's progress for all devotionals in a specified series. Includes completion timestamp when user has reached 90%+ progress.
 * @summary Get devotional series progress
 */
export const getApiDevosSeriesProgressQueryParams = zod.object({
  "seriesId": zod.string().optional()
})

export const getApiDevosSeriesProgressResponse = zod.object({
  "seriesId": zod.string().nullable(),
  "devotionals": zod.array(zod.object({
  "cmsId": zod.string().nullable(),
  "progressPercentage": zod.number().optional(),
  "lastListenedUtc": zod.string().datetime({}).nullish(),
  "completedAtUtc": zod.string().datetime({}).nullish()
})).nullish()
})


/**
 * Returns streak metrics from completion history in the user's timezone.
                       Day streaks are based on consecutive weekdays.
                       Week streak uses Monday-Sunday calendar weeks, and only Monday-Friday completions qualify a week.
                       Saturday/Sunday completions never contribute to weekStreak.
                       A partial current week counts only if it already contains at least one Monday-Friday completion.
 * @summary Get user's listening streak
 */
export const getApiDevosStreakResponse = zod.object({
  "currentStreak": zod.number().optional(),
  "lastListenDate": zod.string().datetime({}).nullish(),
  "longestStreak": zod.number().optional(),
  "weekStreak": zod.number().optional()
})


/**
 * Returns a list of dates when the user completed devotionals (weekdays only).
                       Dates are in ISO format (YYYY-MM-DD) in the user's timezone.
 * @summary Get user's listening history days
 */
export const getApiDevosStreakHistoryResponse = zod.object({
  "dates": zod.array(zod.string()).nullish()
})


/**
 * @summary List of CMS IDs that have been favorited by the user
 */
export const getApiFavoritesResponseItem = zod.string().uuid()
export const getApiFavoritesResponse = zod.array(getApiFavoritesResponseItem)


/**
 * @summary Add a favorite for a user
 */
export const postApiFavoritesBody = zod.object({
  "cmsId": zod.string().uuid()
})


/**
 * @summary Delete a favorite for a user
 */
export const deleteApiFavoritesBody = zod.object({
  "cmsId": zod.string().uuid()
})


/**
 * Used by front-end to confirm that the user is signed in
 * @summary Get user info and confirms cookie is still valid
 */
export const getApiMeResponse = zod.object({
  "id": zod.number().optional(),
  "externalId": zod.string().uuid().optional(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phoneNumber": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "languagePreference": zod.string().nullish(),
  "alwaysShowTranscript": zod.boolean().optional(),
  "hasDevoPlus": zod.boolean().optional(),
  "createdAtUtc": zod.string().datetime({}).optional(),
  "lastLoginAtUtc": zod.string().datetime({}).nullish(),
  "promotionalBannerDismissedAt": zod.string().datetime({}).nullish(),
  "email": zod.string().nullish(),
  "preferredDailyChannel": zod.enum(['Sms', 'Email']).optional(),
  "preferredSendTime": zod.string().time({}).nullish(),
  "optedOutViaApp": zod.string().datetime({}).nullish(),
  "doNotMessage": zod.boolean().optional(),
  "marketingMessageProvider": zod.enum(['Pbt', 'Cio']).optional(),
  "smsMarketingStatus": zod.enum(['OptedIn', 'OptedOut', 'CarrierOptedOut']).nullish(),
  "smsMarketingPreferenceUpdatedAtUtc": zod.string().datetime({}).nullish(),
  "birthYear": zod.number().nullish(),
  "birthMonth": zod.number().nullish(),
  "googlePlaceId": zod.string().nullish(),
  "addressName": zod.string().nullish(),
  "street1": zod.string().nullish(),
  "street2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "region": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish()
})


/**
 * Updates daily text notification preferences from explicit user intent.
 * @summary Update notification settings
 */
export const putApiNotificationSettingsBody = zod.object({
  "dailyTextNotificationsEnabled": zod.boolean(),
  "email": zod.string().nullish(),
  "preferredDailyChannel": zod.enum(['Sms', 'Email']).optional(),
  "preferredSendTime": zod.string().time({}).nullish(),
  "timezone": zod.string().nullish()
})


/**
 * Records explicit SMS marketing consent and assigns Customer.io marketing routing.
 * @summary Update SMS marketing consent
 */
export const putApiNotificationSettingsSmsMarketingConsentBody = zod.object({
  "smsMarketingOptIn": zod.boolean()
})

export const putApiNotificationSettingsSmsMarketingConsentResponse = zod.object({
  "marketingMessageProvider": zod.enum(['Pbt', 'Cio']),
  "smsMarketingStatus": zod.enum(['OptedIn', 'OptedOut', 'CarrierOptedOut']),
  "smsMarketingPreferenceUpdatedAtUtc": zod.string().datetime({}).nullish()
})


/**
 * Used by Twilio webhook when receiving messages
 * @summary Opt user in or out by keyword or opt out type
 */
export const postApiOptInPbtBody = zod.object({
  "type": zod.string().nullable(),
  "message": zod.string().nullable(),
  "subscriberNo": zod.string().nullable(),
  "groupName": zod.string().nullable(),
  "groupId": zod.string().nullable(),
  "messageType": zod.string().nullable()
})


/**
 * Used by PBT webhook when receiving messages
 * @summary Opt user in or out by keyword or opt out type
 */
export const postApiPbtIncomingMessageBody = zod.object({
  "type": zod.string().nullable(),
  "message": zod.string().nullable(),
  "subscriberNo": zod.string().nullable(),
  "groupName": zod.string().nullable(),
  "groupId": zod.string().nullable(),
  "messageType": zod.string().nullable()
})


/**
 * Used by PBT webhook when receiving message status
 * @summary Opt people out once the number receives 3 failures
 */
export const postApiPbtMessageStatusBody = zod.object({
  "externalReferenceId": zod.string().nullable(),
  "communicationCode": zod.string().nullable(),
  "message": zod.string().nullable(),
  "subscriberNo": zod.string().nullable(),
  "groupName": zod.string().nullable(),
  "groupId": zod.string().nullable(),
  "statusCode": zod.string().nullable(),
  "statusCodeDescription": zod.string().nullable()
})


/**
 * Saves referral information for the user
 * @summary Add referral information (utm_)
 */
export const postApiReferralBody = zod.object({
  "utm_source": zod.string().nullable(),
  "utm_medium": zod.string().nullable(),
  "utm_campaign": zod.string().nullable(),
  "utm_term": zod.string().nullish(),
  "utm_content": zod.string().nullish()
})


/**
 * Returns count of users who signed up from the authenticated user's referral links (ref_user)
 * @summary Get referral metrics for authenticated user
 */
export const getApiReferralMetricsQueryParams = zod.object({
  "startDate": zod.string().datetime({}).optional(),
  "endDate": zod.string().datetime({}).optional()
})

export const getApiReferralMetricsResponse = zod.object({
  "userExternalId": zod.string().nullish(),
  "referredUsers": zod.number().optional(),
  "updatedAt": zod.string().datetime({}).optional()
})


/**
 * @summary List of CMS IDs for series that have been followed by the user
 */
export const getApiSeriesFollowResponseItem = zod.string()
export const getApiSeriesFollowResponse = zod.array(getApiSeriesFollowResponseItem)


/**
 * @summary Follow a series for a user
 */
export const postApiSeriesFollowBody = zod.object({
  "cmsId": zod.string().nullable()
})


/**
 * @summary Unfollow a series for a user
 */
export const deleteApiSeriesFollowBody = zod.object({
  "cmsId": zod.string().nullable()
})


/**
 * @summary Record a share event when a user shares content
 */
export const postApiShareEventBody = zod.object({
  "cmsId": zod.string().nullable()
})


/**
 * @summary Get the total share count for a specific content item
 */
export const getApiShareCountCmsIdParams = zod.object({
  "cmsId": zod.string()
})

export const getApiShareCountCmsIdResponse = zod.object({
  "cmsId": zod.string().nullable(),
  "totalShares": zod.number().optional()
})


/**
 * @summary Get the authenticated user's total shares and 5 most recently shared CMS IDs
 */
export const getApiShareMeResponse = zod.object({
  "totalSharesByUser": zod.number().optional(),
  "recentCmsIds": zod.array(zod.string()).nullish()
})


/**
 * Returns minimal display data for a sharer. Unknown users return empty fields.
 * @summary Resolve sharer display name
 */
export const getApiShareSharerExternalIdParams = zod.object({
  "externalId": zod.string().uuid()
})

export const getApiShareSharerExternalIdResponse = zod.object({
  "firstName": zod.string().nullish(),
  "lastInitial": zod.string().nullish()
})


/**
 * Used to get the product pricing for the user.
 * @summary Get Product Pricing
 */
export const getApiStripePricesResponseItem = zod.object({
  "amountDollars": zod.number().optional(),
  "productName": zod.string().nullish(),
  "interval": zod.string().nullish(),
  "intervalCount": zod.number().optional()
})
export const getApiStripePricesResponse = zod.array(getApiStripePricesResponseItem)


/**
 * Used to get the checkout session for the user.
 * @summary Get Checkout Session
 */
export const getApiStripeCheckoutSessionQueryIntervalDefault = "year";

export const getApiStripeCheckoutSessionQueryParams = zod.object({
  "interval": zod.string().default(getApiStripeCheckoutSessionQueryIntervalDefault)
})

export const getApiStripeCheckoutSessionResponse = zod.string()


/**
 * Creates a Stripe checkout session for purchasing promo-code redemptions.
 * @summary Create promo-code purchase checkout session
 */
export const postApiStripePromotionCodeCheckoutSessionBodyQuantityMax = 2147483647;



export const postApiStripePromotionCodeCheckoutSessionBody = zod.object({
  "quantity": zod.number().min(1).max(postApiStripePromotionCodeCheckoutSessionBodyQuantityMax).optional()
})

export const postApiStripePromotionCodeCheckoutSessionResponse = zod.object({
  "sessionId": zod.string().nullable(),
  "clientSecret": zod.string().nullable()
})


/**
 * Returns promo codes purchased by the authenticated user with live Stripe redemption state.
 * @summary Get my owned promotion codes
 */
export const getApiStripePromotionCodeMyResponse = zod.object({
  "promotionCodes": zod.array(zod.object({
  "stripePromotionCodeId": zod.string().nullable(),
  "promotionCode": zod.string().nullable(),
  "stripeCouponId": zod.string().nullable(),
  "stripeCheckoutSessionId": zod.string().nullable(),
  "quantityPurchased": zod.number().optional(),
  "timesRedeemed": zod.number().optional(),
  "maxRedemptions": zod.number().nullish(),
  "remainingRedemptions": zod.number().nullish(),
  "active": zod.boolean().optional(),
  "createdAtUtc": zod.string().datetime({}).optional()
})).nullish()
})


/**
 * Returns information about the user's subscription status including key dates
 * @summary Get Subscription Status
 */
export const getApiStripeSubscriptionStatusResponse = zod.object({
  "signupDate": zod.string().datetime({}).optional(),
  "subscriptionStartDate": zod.string().datetime({}).nullish(),
  "subscriptionEndDate": zod.string().datetime({}).nullish(),
  "nextBillingDate": zod.string().datetime({}).nullish(),
  "hasEverUsedTrial": zod.boolean().optional(),
  "billingInterval": zod.string().nullish(),
  "status": zod.string().nullish(),
  "trial": zod.object({
  "isInTrial": zod.boolean().optional(),
  "trialEndDate": zod.string().datetime({}).nullish(),
  "trialDaysRemaining": zod.number().nullish()
}).optional(),
  "totalCost": zod.number().nullish(),
  "nextBillingAmountBeforeDiscount": zod.number().nullish(),
  "discounts": zod.array(zod.object({
  "couponId": zod.string().nullish(),
  "couponName": zod.string().nullish(),
  "amountOffCents": zod.number().nullish(),
  "amountOffDollars": zod.number().nullish(),
  "percentOff": zod.number().nullish(),
  "duration": zod.string().nullish(),
  "promotionCode": zod.string().nullish(),
  "activeUntil": zod.string().datetime({}).nullish()
})).nullish(),
  "paymentMethod": zod.object({
  "type": zod.string().nullish(),
  "last4": zod.string().nullish(),
  "brand": zod.string().nullish(),
  "cardName": zod.string().nullish(),
  "bankName": zod.string().nullish(),
  "accountType": zod.string().nullish(),
  "routingLast4": zod.string().nullish(),
  "accountLast4": zod.string().nullish()
}).optional(),
  "pricing": zod.object({
  "standardItemPrice": zod.number().nullish()
}).optional(),
  "billing": zod.object({
  "recent": zod.object({
  "amount": zod.number().nullish(),
  "date": zod.string().datetime({}).nullish(),
  "couponApplied": zod.boolean().optional(),
  "coupon": zod.object({
  "id": zod.string().nullish(),
  "code": zod.string().nullish(),
  "name": zod.string().nullish(),
  "amountOffDollars": zod.number().nullish(),
  "percentOff": zod.number().nullish(),
  "duration": zod.string().nullish(),
  "durationInMonths": zod.number().nullish()
}).optional()
}).optional(),
  "next": zod.object({
  "amount": zod.number().nullish(),
  "date": zod.string().datetime({}).nullish(),
  "couponApplied": zod.boolean().optional(),
  "coupon": zod.object({
  "id": zod.string().nullish(),
  "code": zod.string().nullish(),
  "name": zod.string().nullish(),
  "amountOffDollars": zod.number().nullish(),
  "percentOff": zod.number().nullish(),
  "duration": zod.string().nullish(),
  "durationInMonths": zod.number().nullish()
}).optional()
}).optional()
}).optional()
})


/**
 * Generates a URL to the Stripe billing portal for the authenticated user
 * @summary Get Stripe billing portal URL
 */
export const getApiStripeBillingPortalResponse = zod.object({
  "url": zod.string().nullable()
})


/**
 * Generates a URL to the Stripe billing portal specifically for updating payment methods
 * @summary Get Stripe payment method update portal URL
 */
export const getApiStripePaymentMethodPortalResponse = zod.object({
  "url": zod.string().nullable()
})


/**
 * Returns information about a promotion code including discount details,
                           validity, and expiration. Use this to validate codes before checkout.
 * @summary Validate and retrieve promotion code information
 */
export const getApiStripePromotionCodeQueryParams = zod.object({
  "code": zod.string().optional()
})

export const getApiStripePromotionCodeResponse = zod.object({
  "code": zod.string().nullish(),
  "isValid": zod.boolean().optional(),
  "invalidReason": zod.string().nullish(),
  "active": zod.boolean().optional(),
  "expiresAt": zod.string().datetime({}).nullish(),
  "amountOffDollars": zod.number().nullish(),
  "percentOff": zod.number().nullish(),
  "currency": zod.string().nullish(),
  "duration": zod.string().nullish(),
  "durationInMonths": zod.number().nullish(),
  "couponName": zod.string().nullish(),
  "metadata": zod.record(zod.string(), zod.string()).nullish()
})


/**
 * Creates a Stripe subscription with a promotion code applied.
 * @summary Create subscription with 100% off coupon
 */



export const postApiStripeSubscriptionCreateWithCouponBody = zod.object({
  "promotionCode": zod.string().min(1)
})

export const postApiStripeSubscriptionCreateWithCouponResponse = zod.object({
  "subscriptionId": zod.string().nullable(),
  "status": zod.string().nullable(),
  "currentPeriodEnd": zod.string().datetime({}).nullish(),
  "nextBillingDate": zod.string().datetime({}).nullish(),
  "appliedPromotionCode": zod.object({
  "code": zod.string().nullish(),
  "isValid": zod.boolean().optional(),
  "invalidReason": zod.string().nullish(),
  "active": zod.boolean().optional(),
  "expiresAt": zod.string().datetime({}).nullish(),
  "amountOffDollars": zod.number().nullish(),
  "percentOff": zod.number().nullish(),
  "currency": zod.string().nullish(),
  "duration": zod.string().nullish(),
  "durationInMonths": zod.number().nullish(),
  "couponName": zod.string().nullish(),
  "metadata": zod.record(zod.string(), zod.string()).nullish()
}).optional()
})


/**
 * Updates user profile with partial update support. Only provided fields are updated.

    Demographic fields (birthYear, birthMonth) update independently.
    Church/address fields update as a set - if any church field is provided, all church fields are updated together.
 * @summary Update user profile
 */
export const putApiUserBody = zod.object({
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "email": zod.string().nullish(),
  "alwaysShowTranscript": zod.boolean().optional(),
  "preferredSendTime": zod.string().time({}).nullish(),
  "timezone": zod.string().nullish(),
  "languagePreference": zod.string().nullish(),
  "birthYear": zod.number().nullish(),
  "birthMonth": zod.number().nullish(),
  "googlePlaceId": zod.string().nullish(),
  "addressName": zod.string().nullish(),
  "street1": zod.string().nullish(),
  "street2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "region": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish()
})
